import { ArrowDropDown } from "@mui/icons-material";
import { Link, MenuItem, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";

export default function PageLink({
  label,
  route,
  onClick,
  mobile,
  menu,
}: {
  label: string;
  route: string;
  onClick: (event: React.MouseEvent) => void;
  onClose?: () => void;
  mobile?: boolean;
  menu?: boolean;
}) {
  if (mobile) {
    return (
      <Link
        component={RouterLink}
        to={route}
        underline="none"
        color="black"
        onClick={onClick}
      >
        <MenuItem className="PageLink PageLink-Mobile" sx={{ minWidth: "90px" }}>
          <Typography
            sx={{
              textAlign: "center",
            }}
          >
            {label}
          </Typography>
        </MenuItem>
      </Link>
    );
  }
  return (
    <Link
      className="PageLink"
      component={RouterLink}
      underline="none"
      color="black"
      to={route}
      key={label}
      onClick={onClick}
    >
      <Typography
        variant="subtitle1"
        className="NavBar-Link-Desktop"
        component="div"
      >
        {label}
        {menu ? <ArrowDropDown /> : null}
      </Typography>
    </Link>
  );
}
